class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.header = this.querySelector(".header");
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.closeBtn = this.querySelector(".btn-close");
    this.overlayScreen = document.querySelector(".overlay-screen-master");

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    // Attach height to outer
    setObservableHeight(this.header);

    // Events to Hide/show search bar
    this.nav = document.querySelector("#header");
    this.searchBar = document.querySelector("predictive-search.sticky");
    this.searchBtns = header.querySelectorAll(".btn-search");

    this.searchBtns.forEach((btn) => {
      btn.addEventListener("click", () => this.toggle());
    });

    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });

    // Click on overlay screen to hide
    this.overlayScreen.addEventListener("click", () => {
      this.hide();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        // console.log(text);

        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.classList.add("active");
  }

  close() {
    this.predictiveSearchResults.classList.remove("active");
  }

  toggle() {
    if (this.searchBar.classList.contains("active")) {
      this.hide();
    } else {
      this.searchBar.classList.toggle("active");
      this.nav.classList.add("search-active");
      this.input.focus();
    }
  }

  hide() {
    this.classList.remove("active");
    this.input.value = "";
    this.predictiveSearchResults.classList.remove("active");
    this.predictiveSearchResults.innerHTML = "";
    this.nav.classList.remove("search-active");
  }
}
customElements.define("predictive-search", PredictiveSearch);
